import { useState, useContext, useEffect, useRef } from 'react';
import AuthContext from '../../contexts/auth';
import { exportToExcel, exportToExcelCustome, exportToPDF } from '../../utils/Common';
import Results from './Results';
import ItemsPagination from './ItemsPagination';
import './index.css';
import { exportConfig } from '../../config/exportPdf';
import BoxLoaders from './BoxLoaders';

const ShowItems = ({ 
    ItemComponent, itemsFound, itemName, showBox, handleCancelBusqueda, setSelectedItem, itemsShowing, view, typeExport, handleUpdateData, isLoading, typeList="pkgs-reserv", visibleColumns, renderers, version, canExport = true, canExportExcel = true
}) => {
    const userContext = useContext(AuthContext);
    const [actualPage, setActualPage] = useState(Number(sessionStorage.getItem('currentPage')) ? Number(sessionStorage.getItem('currentPage')) : 1);
    const [pages, setPages] = useState(Math.ceil(itemsFound.length / itemsShowing));

    const exportData = (data) => {
        
        const config = exportConfig[typeExport || "packages"];

        if (!config) {
            console.error(`Export type "${typeExport}" is not defined.`);
            return;
        }

        const columns = config.columns;
        const mapData = config.mapData;
        const fileNamePrefix = config.fileNamePrefix;
        const reportName = config.reportName;
        const reportDescription = config.reportDescription;
        
        const rows = data.map(item => mapData(item, userContext?.user.IdTipoUsuario));
        
        const fileName = fileNamePrefix[itemName] || fileNamePrefix.default;
        const reportTitle = reportName[itemName] || reportName.default;

        exportToPDF(reportTitle, fileName + "Boxit", columns, rows, reportDescription);
    }

    const exportDataExcel = (data) => {
      const columns = visibleColumns.map((col) => ({
        title: col.name,
        dataKey: col.id,
      }));
    
      const rows = data.map((item) => {
        const row = {};
        visibleColumns.forEach((col) => {
          if (renderers[col.id]) {
            // Aquí pasamos TRUE para indicar que queremos solo el texto
            const renderedValue = renderers[col.id](item, true);
            row[col.id] = renderedValue;
          } else {
            row[col.id] = item[col.id];
          }
        });
        return row;
      });
    const currentDate = new Date();
    const formattedDate = `${String(currentDate.getDate()).padStart(2, '0')}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${currentDate.getFullYear()}`;
    const fileName = `reportBoxit_${formattedDate}`;

      exportToExcelCustome(fileName, "ExcelBoxit", columns, rows);
    };
    
    useEffect(() => {
        if (actualPage >= pages) setActualPage(pages);
        if (actualPage === 0) setActualPage(1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pages])
    
    useEffect(() => {
        if (Math.ceil(itemsFound.length / itemsShowing) !== pages) setPages(Math.ceil(itemsFound.length / itemsShowing));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [itemsFound, itemsShowing]);

    return (
      <>
          {isLoading ? (
            <BoxLoaders view={view}/>
          ) : (
            <Results
              ItemComponent={ItemComponent}
              itemName={itemName}
              showBox={showBox}
              setSelectedItem={setSelectedItem}
              itemsFound={itemsFound}
              actualPage={actualPage}
              itemsShowing={itemsShowing}
              view={view}
              handleUpdateData={handleUpdateData}
              typeList={typeList}
              visibleColumns={visibleColumns}
              renderers={renderers}
              version={version}
            />
          )}
        {itemsFound?.length > 0 && (
          <ItemsPagination
            actualPage={actualPage}
            setActualPage={setActualPage}
            pages={pages}
            itemsFound={itemsFound}
            exportData={exportData}
            itemName={itemName}
            handleCancelBusqueda={handleCancelBusqueda}
            version={version}
            exportDataExcel={ exportDataExcel }
            canExport={canExport}
            canExportExcel={canExportExcel}
          />
        )}
      </>
    );
}

export default ShowItems;